import React from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import IcnChevronRight from "@assets/icons/chevron-right-sharp.svg";

import { MenuItem as IMenuItem } from "@app/api/core/menu-item/menu-item";
import { IconComponent } from "@app/core";

import styles from "./priority-menu-item.module.scss";
import { formatMessage } from "@app/translations/intl";

interface IProps {
  menuItem: IMenuItem;
  index: number;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export const component = ({ onClick, menuItem, index }: IProps & RouteComponentProps) => {
  return (
    <Link onClick={onClick} className={styles.root} to={menuItem.url || ""}>
      <div className={styles.text}>
        <span className={styles.title}>{menuItem.title}</span>
        <span className={styles.subtitle}>
          {formatMessage({ id: `mobileNavMenu.priorityMenuItem.${index}.subtitle` })}
        </span>
      </div>
      <div className={styles.arrow}>
        <div className={styles.icon}>
          <IconComponent icon={IcnChevronRight} size="12px" />
        </div>
      </div>
    </Link>
  );
};

const PriorityMenuItem = withRouter(component);
export { PriorityMenuItem };
